const appendAccrualPeriodToFormData = (period, periodValues, formData) => {
    if (period === "days") {
        formData.append("custom_dates", periodValues.map((v) => v.date).join(","));
    }
    if (period === "week") {
        formData.append("week_dates", periodValues.map((v) => v - 1).join(","));
    }
    if (period === "month") {
        formData.append("month_dates", periodValues.join(","));
    }
    if (period === "year") {
        formData.append("year_dates", periodValues.map((v) => v.date).join(","));
    }
};

export const getFormDataForSurcharge = (surchargeData) => {
    const formData = new FormData();

    const surchargeType = surchargeData.surchargeType === "percent" ? "1" : "2";

    formData.append("surcharge_type", surchargeType);
    formData.append("surcharge_value", surchargeData.surchargeAmount);

    const period = surchargeData.accrualPeriod.value;
    formData.append("period", period);

    appendAccrualPeriodToFormData(period, surchargeData.accrualPeriodValue, formData);

    if (surchargeData.actionPeriods.length) {
        surchargeData.actionPeriods.forEach((period) => {
            const [periodStart, _, periodEnd] = period.value.split(" "); //  eslint-disable-line
            if (!periodStart || !periodEnd) {
                return;
            }
            formData.append("validity_start[]", periodStart);
            formData.append("validity_finish[]", periodEnd);
        });
    }

    if (surchargeData.name) {
        formData.append("name", surchargeData.name);
    }
    const { start, end } = surchargeData.shift;
    if (start && end) {
        formData.append("timebeg", start);
        formData.append("timeend", end);
    }
    if (surchargeData.positions.length) {
        surchargeData.positions.forEach((position) => {
            formData.append("post_codes[]", position.value);
        });
    }
    if (surchargeData.filials.length) {
        surchargeData.filials.forEach((filial) => {
            formData.append("filials[]", filial.value);
        });
    }
    if (surchargeData.workersToExclude.length) {
        formData.append("workers_exclude", surchargeData.workersToExclude.map((w) => w.value).join(","));
    }

    return formData;
};
